import { g as a } from "./_commonjsHelpers-B52_cu2H.js";
import { r as i } from "./set-CmOi9Z8k.js";
import { r as u } from "./get-C86WHrhh.js";
import { r as m } from "./_baseConvert-B-C9YFBB.js";
var r, t;
function s() {
  if (t) return r;
  t = 1;
  var o = i(), e = o("get", u());
  return e.placeholder = m(), r = e, r;
}
var f = s();
const v = /* @__PURE__ */ a(f);
export {
  v as g
};
